import React from 'react';
import Dashboard from '../components/StudentDashboard/Dashboard';
import Layout from '../components/StudentDashboard/Layout';
import { Navigate } from 'react-router-dom';

export default function StudentDashboard() {
  document.title = 'Dashboard Page';
  return (
    <Layout>
      <Dashboard />
      <Navigate to="/course-advising" replace={true} />
    </Layout>
  );
}
